<template>
    <div class="lang-currency-switcher-wrap" id="currency-switcher">
        <div class="lang-currency-switcher dropdown-toggle">
            <span class="currency">{{ currency }}</span>
        </div>

        <div class="dropdown-menu">
            <a class="dropdown-item" href="javascript:void(0);"
               :class="{ current: currency === c.value }"
               v-for="c in currencies"
               :key="c.value"
               @click="switchCurrency(c.value)"
            >
                {{ c.symbol }} {{ c.value }}
            </a>
        </div>
    </div>
</template>

<script>
  import { mapState } from 'vuex';
  /* globals $ */

  export default {
    name: 'CurrencySwitcher',
    mounted() {
      $('#currency-switcher').on('click', function () {
        $(this).parent().addClass('show');
        $(this).parent().find('.dropdown-menu').addClass('show');
      });
      $(document).on('click', (event) => {
        if (!$(event.target).closest('#currency-switcher').length) {
          $('#currency-switcher').removeClass('show');
          $('#currency-switcher .dropdown-menu').removeClass('show');
        }
      });
    },
    data() {
      return {
        currencies: {
          HKD: {
            value: 'HKD',
            symbol: '$',
          },
          CNY: {
            value: 'CNY',
            symbol: '¥',
          },
          USD: {
            value: 'USD',
            symbol: '$',
          },
          JPY: {
            value: 'JPY',
            symbol: '¥',
          },
          GBP: {
            value: 'GBP',
            symbol: '£',
          },
          EUR: {
            value: 'EUR',
            symbol: '€',
          },
        },
      };
    },
    computed: {
      ...mapState({
        currency: state => state.app.currency,
      }),
    },
    methods: {
      switchCurrency(currency) {
        this.$store.dispatch('setCurrency', currency).then(() => {
          this.$router.go(0);
        }).catch(() => {});
      },
    },
  };
</script>
